<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧校园</h2>
        <h3>车辆自动识别系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview">
        <div>
          <h2>车辆自动识别系统</h2>
          <p>
            车牌识别核心部件，该产品采用目前国际最先进的计算机视觉技 术，对视频流中的高速行驶车辆进行实时检测、识别，彻底抛弃 了外部触发，解决了维护成本问题。 设备采用嵌入式的智能高清车牌识别一体机产品，独家集车牌识 别、摄像、前端储存、补光等一体，采用高清宽动态CMOS和TI DSP，峰值计算能力高达6.4Ghz。基于车牌自动曝光控制算法，成
            像优异。具有极佳性能、多功能、高适应性、强稳定性等特点，是 停车场管理系统车牌识别功能的最佳应用形态。
          </p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix mb100">
        <li>
          <h2>车牌识别</h2>
          <p>支持牌照类型：普通蓝牌、黑牌、黄牌、双层黄牌、警车车牌、新式武警车 牌、新式军牌、使馆车牌、港澳进出大陆车牌，适应车速：0-150公里/小时 识别特征：号码、颜色、类型、宽度。输出结果：车辆特征图像、车牌图 像、牌照号码、颜色、类型、通过时间。</p>
        </li>
        <li>
          <h2>成像</h2>
          <p>高清H.264，MJpeg输出；支持输出JPEG格式抓图，支持线圈、视频、485网络 等触发方式，支持智能自动、手动调节白平衡，手动调光，基于图像的灯光控制 基于车牌亮度的曝光控制</p>
        </li>
        <li>
          <h2>其他多样化功能</h2>
          <p>支持连续视频采集与抓拍同时具备的工作模式，并且两种模式的成像参数独立控制 支持OSD信息叠加，具有即时上报工作状态功能，包括：工作状态、客户端连接状态等 支持网络自动连接、即插即用</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Sscarrecognition',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
